import { Scene } from 'phaser';
import { initLocalization, t } from '../i18n/Localization';

export class Trophies extends Scene {
  constructor() {
    super('Trophies');
  }

  create(): void {
    initLocalization(this);
    const { width, height } = this.scale;

    this.add.rectangle(width / 2, height / 2, width, height, 0x0d1f33, 1);

    this.add.text(width / 2, height * 0.2, t('trophies.title'), {
      fontFamily: 'Crackvetica, Arial',
      fontSize: '56px',
      color: '#ffffff',
      stroke: '#000000',
      strokeThickness: 6,
    }).setOrigin(0.5);

    this.add.text(width / 2, height * 0.48, t('trophies.placeholder'), {
      fontFamily: 'Arial Black',
      fontSize: '26px',
      color: '#9fffd0',
      align: 'center',
    }).setOrigin(0.5);

    const back = this.add.text(width / 2, height * 0.84, t('ui.back'), {
      fontFamily: 'Arial Black',
      fontSize: '28px',
      color: '#ffffff',
    }).setOrigin(0.5);

    back.setInteractive({ useHandCursor: true });
    back.on('pointerover', () => back.setColor('#ffd34d'));
    back.on('pointerout', () => back.setColor('#ffffff'));
    back.on('pointerdown', () => this.scene.start('MainMenu'));
  }
}

